class DnavComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.detailsElements = this.querySelectorAll('.dnav__details');
    this.detailsElements.forEach(details => {
      details.addEventListener('toggle', this.handleDetailsToggle.bind(this));
    });
  }

  disconnectedCallback() {
    if (this.detailsElements) {
      this.detailsElements.forEach(details => {
        details.removeEventListener('toggle', this.handleDetailsToggle.bind(this));
      });
    }
  }

  handleDetailsToggle(event) {
    const currentDetails = event.target;

    if (currentDetails.open) {
      // Close all other details elements
      this.detailsElements.forEach(details => {
        if (details !== currentDetails && details.open) {
          details.open = false;
        }
      });

      const content = currentDetails.querySelector('.dnav__content');
      if (content) {
        content.classList.remove('dnav__content--right');
        requestAnimationFrame(() => {
          if (content.getBoundingClientRect().right > window.innerWidth) {
            content.classList.add('dnav__content--right');
          }
        });
      }
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    
  }

  static get observedAttributes() {
    return [];
  }
}

if (!customElements.get('dnav-component')) {
  customElements.define('dnav-component', DnavComponent);
}
